
import React, { useEffect, useState } from "react";
import "./TextBox.css";
import "../Table.css";
import { useTranslation } from "react-i18next";

const TextBox = ({
  label,
  defaultValue = "",
  onChange,
  readOnly,
  validators = [],
  isRequired = false,
  error,
  border = "",
  rows = 3,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [errors, setErrors] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const validatorArray = Array.isArray(validators)
    ? validators
    : validators
      ? [validators]
      : [];

  // Add isRequired validator if required prop is true
  const effectiveValidators = isRequired
    ? [
        ...(typeof validatorArray === "function"
          ? [validatorArray]
          : validatorArray),
        (val) =>
          (val !== null && val !== undefined && val !== "") ||
          "This field is required",
      ]
    : validatorArray;

  const validateInput = (inputValue) => {
    // Run all validators
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === "function") {
          const result = validator(inputValue);
          // Return error message if validation fails
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === "string");

    return newErrors;
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;

    // Validate input
    const newErrors = validateInput(newValue);

    // Update state
    setValue(newValue);
    setErrors(newErrors);

    // Call onChange regardless of validation (to allow parent component to track changes)
    if (onChange) {
      onChange(event);
    }
  };

  const displayErrors = error ? [error] : errors;

  return (
    <div className="text-box-container common-text ftw-4">
      <textarea
        className={`text-box common-text ftw-4 ${displayErrors.length > 0 ? "input-error" : ""} ${border}`}
        value={value}
        onChange={handleInputChange}
        placeholder=" "
        rows={rows}
        readOnly={readOnly}
      />
      {readOnly ? (
        <label className={`text-label common-text ftw-4 has-value `}>
          {t(label)}
        </label>
      ) : (
        <label
          className={`text-label common-text ftw-4 ${value ? "has-value" : ""}`}
        >
          {t(label)}
        </label>
      )}
      {/* {displayErrors.length > 0 && (
        <div className="input-error-message common-text  red">
          {displayErrors[0]}
        </div>
      )} */}
    </div>
  );
};

export default TextBox;
